import {Form, Formik} from 'formik'
import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import * as Yup from 'yup'
import {CustomButton} from '../../widgets/components/UI/CustomButton'
import {updateIndustryFocus} from '../core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import Select from 'react-select'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {industryOptions} from '../../../core/_constants'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

export const AddIndustryFocusModal = ({
  showIndustryFocusModal,
  setShowIndustryFocusModal,
  getAllIndustryFocus,
  industryFocusData,
}: {
  showIndustryFocusModal: boolean
  setShowIndustryFocusModal: Dispatch<SetStateAction<boolean>>
  getAllIndustryFocus: any
  industryFocusData: any
}) => {
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const {companyId, currentUser} = useAuth()
  const [initialFocusArea, setInitialFocusArea] = useState<any>([])
  const [focusArea, setFocusArea] = useState<any>([])
  const [investorFocusArea, setInvestorFocusArea] = useState<any>([])
  const [errorIndustryFocus, setErrorIndustryFocus] = useState<string>()

  const initialValues = {
    focusArea: '',
  }

  const industryFocusSchema = Yup.object().shape({
    focusArea: Yup.string().nullable(),
  })

  const onSubmit = async () => {
    let focus_area = focusArea.map((e: any) => e.value)
    if (focus_area.length === 0) {
      setLoading(false)
      setErrorIndustryFocus(formatMessage({id: 'Industry Focus is required'}))
      return
    }
    const payload = {
      industries: focus_area,
    }
    try {
      setLoading(true)
      if (companyId) {
        const {
          data: {success, errors},
        } = await updateIndustryFocus(companyId, payload)
        if (success) {
          getAllIndustryFocus(companyId)
          setLoading(false)
          setShowIndustryFocusModal(false)
          toast.success(formatMessage({id: 'Industry Focus updated successfully'}))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateIndustryFocusSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                industries: payload?.industries,
              }),
            },
          })
        } else {
          setLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateIndustryFocusFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                industries: payload?.industries,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const handleChangeFocusArea = (selectedOptions: any) => {
    setInitialFocusArea(selectedOptions)
    setFocusArea(selectedOptions)
    setErrorIndustryFocus('')
  }

  useEffect(() => {
    let investorFocusAreaData = industryOptions.map((e: any) => {
      return {value: e.value, label: e.name}
    })
    setInvestorFocusArea(investorFocusAreaData)
  }, [])

  useEffect(() => {
    if (industryFocusData) {
      setInitialFocusArea(
        industryFocusData?.map(({industry}: {industry: string}) => {
          return {value: industry, label: industry}
        })
      )
    }
  }, [industryFocusData]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Modal
      size='lg'
      show={showIndustryFocusModal}
      onHide={() => setShowIndustryFocusModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Formik
        initialValues={initialValues}
        validationSchema={industryFocusSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              <Modal.Body>
                <div className='d-flex justify-content-between m-5'>
                  <h2>{formatMessage({id: 'Edit Industry Focus'})}</h2>
                  <img
                    src={toAbsoluteUrl('/media/icons/investor/Cancel.svg')}
                    alt={formatMessage({id: 'cancel'})}
                    className='cursor-pointer'
                    onClick={() => {
                      setShowIndustryFocusModal(false)
                    }}
                  />
                </div>
                <div className='mt-8 m-5 w-100'>
                  <div className='col-11  target-sector'>
                    <label className='bold text-dark text-capitalize font-size-13 form-label'>
                      {formatMessage({id: 'Industry Focus'})}*
                    </label>
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.INDUSTRY_FOCUS_MODAL.INDUSTRY_FOCUS',
                      })}
                    />
                    <div className='highlight-multi-select font-size-12 text-bold mobile-investorType'>
                      <Select
                        isMulti
                        name='focusArea'
                        options={investorFocusArea!}
                        className='basic-multi-select mb-7 mb-md-0 custom-select'
                        onChange={handleChangeFocusArea}
                        placeholder={formatMessage({id: 'Choose Industry Focus'})}
                        classNamePrefix='react-select'
                        value={initialFocusArea}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderColor: errorIndustryFocus ? 'red' : provided.borderColor,
                            backgroundColor: errorIndustryFocus
                              ? 'rgba(241, 65, 108, 0.2)'
                              : provided.backgroundColor,
                          }),
                        }}
                      />
                      <div className='mt-2 mb-4'>
                        {errorIndustryFocus && (
                          <span className='text-danger font-size-13'> {errorIndustryFocus}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className='p-0'>
                <button
                  type='button'
                  className='btn btn-light font-size-13 font-weight-400'
                  onClick={() => {
                    setShowIndustryFocusModal(false)
                  }}
                >
                  {formatMessage({id: 'Cancel'})}
                </button>
                <CustomButton
                  isSubmitting={formik.isSubmitting}
                  isValid={formik.isValid}
                  buttonText={formatMessage({
                    id: 'Edit Focus Industry',
                  })}
                  loading={loading}
                  widthLoading={2}
                  width={2}
                  margin={'me-5 mt-5'}
                />
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}
